<template>
  <div>
    <div v-for="(partner, index) in partners" :key="index" class="row g-2">
      <form-input
        className="col-12 col-md-6 form-input"
        label="Nome"
        v-model="partner.name"
        :id="`partners[${index}].name`"
        :name="`partners[${index}].name`"
        type="text"
        :isDisabled="isDisabled"
      />
      <form-input
        className="col-12 col-md-6 form-input"
        label="Telefone"
        v-model="partner.phone"
        :id="`partners[${index}].phone`"
        :name="`partners[${index}].phone`"
        type="text"
        :isDisabled="isDisabled"
      />
      <form-input
        className="col-12 col-md-12 form-input"
        label="CPF"
        v-model="partner.cpf"
        :id="`partners[${index}].cpf`"
        :name="`partners[${index}].cpf`"
        type="text"
        :isDisabled="isDisabled"
      />
      <form-input
        className="col-12 col-md-6 form-input"
        label="E-mail"
        v-model="partner.email"
        :id="`partners[${index}].email`"
        :name="`partners[${index}].email`"
        type="text"
        :isDisabled="isDisabled"
      />
      <form-input
        className="col-12 col-md-6 form-input"
        label="Participação (%)"
        v-model="partner.percentage"
        :id="`partners[${index}].percentage`"
        :name="`partners[${index}].percentage`"
        type="text"
        :isDisabled="isDisabled"
      />

      <form-switch
        className="col-12 form-input"
        description="O sócio assina pela empresa?"
        v-model="partner.canSignContracts"
        :id="`partners[${index}].canSignContracts`"
        :name="`partners[${index}].canSignContracts`"
      />

      <form-money
        v-if="partner.canSignContracts"
        className="col-12 form-input mb-3"
        v-model="partner.avgMonthlyIncome"
        label="Renda média mensal"
        :id="`partners[${index}].avgMonthlyIncome`"
        :name="`partners[${index}].avgMonthlyIncome`"
        :config="moneyFormat('R$ ', '.', ',', 2)"
      />

      <form-button
        class="col-12 form-input"
        buttonColor="fifth mt-0 mb-4"
        title="Remover Sócio"
        :isDisabled="isDisabled"
        @click.prevent="removePartner(index)"
      />
    </div>

    <div v-if="partners.length > 0" class="row">
      <div class="text-center">
        <img class="line-svg" :src="loadAsset('icon/svg/line_add.svg')" />
      </div>
    </div>
    <form-button
      class="col-12 form-input mt-0"
      buttonColor="secondary mt-1"
      title="Adicionar Sócio"
      :isDisabled="isDisabled"
      @click.prevent="addNewPartner"
    />
  </div>
</template>
<script>
import { loadAsset } from '@shared/utils/loadAsset.ts'
import { moneyFormat } from '@shared/utils/moneyConfig'
import { formButton, formInput, formMoney, formSwitch } from 'tb-design_system-web'
import { reactive, watch } from 'vue'

export default {
  name: 'appBusinessPartners',

  components: {
    formInput,
    formSwitch,
    formMoney,
    formButton
  },
  props: {
    businessPartners: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const partners = reactive([...props.businessPartners])

    watch(
      props.businessPartners,
      (newValue) => {
        partners.splice(0, partners.length, ...newValue)
      },
      { immediate: true, deep: true }
    )

    function addNewPartner() {
      partners.push({
        name: '',
        phone: '',
        email: '',
        percentage: ''
      })
      emit('businessPartners', partners)
    }

    function removePartner(index) {
      partners.splice(index, 1)
      emit('businessPartners', partners)
    }

    return {
      partners,
      addNewPartner,
      removePartner,
      loadAsset,

      moneyFormat
    }
  }
}
</script>

<style lang="scss">
.form-check {
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  background-color: #f2f2f2;
  border-radius: 6px;
  padding: 10px 10px 10px 34px;

  .form-check-label {
    cursor: pointer;
  }
}
.form-input {
  button {
    &.fifth {
      color: var(--sixth-color);
      border-color: var(--fifth-color);
      background-color: var(--fifth-color);

      &:hover,
      &:focus {
        color: var(--sixth-color);
        border-color: var(--fifth-color);
        background-color: var(--fifth-color);
      }
    }
  }
}
</style>
